export default string => {
    return string.charAt(0).toLowerCase() + string.slice(1);
};
